// extracted by mini-css-extract-plugin
export var drawerPaper = "_2k-0";
export var itemCard = "_2k-1";
export var itemImage = "_2k-2";